import { Injectable } from "@angular/core";
import { ImportOrderDocumentGateway } from "../gateway/ImportOrderDocumentGateway";
import { HttpClient } from "@angular/common/http";
import { DocumentStageGateway } from "../gateway/DocumentStageGateway";
import { Observable } from "rxjs";
import { DocumentStage } from "src/app/domain/models/DocumentStage";
import { Routes } from "src/app/infrastructure/routes";

@Injectable({providedIn: 'root'})

export class DocumentStageService extends DocumentStageGateway {

    constructor(private _http: HttpClient){
        super()
    }

    getAll(): Observable<DocumentStage[]> {
            return this._http.get<DocumentStage[]>(Routes.documentStageApi + '/GetAll')
    }
    
}